module.exports = __webpack_public_path__ + "static/img/HR Compliance.c3028c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/HR Compliance.png
// module id = gLSi
// module chunks = 0